import React from 'react'
import {
  Modal,
  SimpleGrid,
  Card,
  Text,
  Stack,
  Button,
  Group,
  LoadingOverlay,
} from '@mantine/core'
import { useWidgetEditor } from './state'
import { registry } from './registry'

export function AddWidgetModal() {
  const editor = useWidgetEditor()
  const isAddMode = editor.useIsEditMode(null, 'add')
  const isSaving = editor.useIsSaving()

  const handleAddWidget = React.useCallback(
    async (widgetType: string) => {
      await editor.addChildWidget(widgetType)
    },
    [editor]
  )

  return (
    <Modal
      opened={isAddMode}
      onClose={editor.endEditWidget}
      title="Add Widget"
      size="lg"
      centered
    >
      {isSaving && <LoadingOverlay visible />}
      <Stack>
        <Text size="sm" c="dimmed">
          Select a widget type to add to the container
        </Text>
        <SimpleGrid cols={2} spacing="md">
          {Object.entries(registry).map(([type, entry]) => (
            <Card
              key={type}
              shadow="sm"
              padding="lg"
              radius="md"
              withBorder
              style={{
                cursor: 'pointer',
                transition: 'all 0.2s ease',
              }}
              onClick={() => handleAddWidget(type)}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = 'translateY(-2px)'
                e.currentTarget.style.boxShadow =
                  '0 4px 12px rgba(0, 0, 0, 0.15)'
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)'
                e.currentTarget.style.boxShadow = ''
              }}
            >
              <Stack gap="md">
                <Text fw={600} size="lg">
                  {type}
                </Text>
                <div
                  style={{
                    border: '1px solid #e0e0e0',
                    borderRadius: '4px',
                    padding: '12px',
                    backgroundColor: '#f8f9fa',
                  }}
                >
                  <entry.mock />
                </div>
              </Stack>
            </Card>
          ))}
        </SimpleGrid>
        <Group justify="flex-end" mt="md">
          <Button variant="subtle" onClick={editor.endEditWidget}>
            Cancel
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
